import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Attribute } from 'src/app/models/attribute';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactAttributeService {

  constructor(private http: HttpClient) { }

    url1 = environment.serverAPI9 + "/api/contact/eavattribute";

  
    deleteByAttributId(id: any): Observable<Object> {
      return this.http.delete(`${this.url1}/${id}`);
    }
    searchAttribute(query, Page: any, size: any, sort: any): Observable<Object> {
      return this.http.get(`${this.url1}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
      }
  
  
    getAttribute(Page: number, size: number, sort: number, typeId: any): Observable<Object> {
      return this.http.get(`${this.url1}?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`);
    }
  
    getAttributeConfigurable(attributeSetId:number,Page: number, size: number, sort: number): Observable<Object> {
      return this.http.get(`${this.url1}/configureable/${attributeSetId}?page=${Page}&size=${size}&sort=${sort}`);
    }
  
    searchAttributeConfigurable(attributeSetId: any, search: any, Page: number, size: number, sort: number) {
      return this.http.post<Response[]>(`${this.url1}/configureable/search/${attributeSetId}?page=${Page}&size=${size}&sort=${sort}`, search);
      }
  
  
    getAttributeById(attributeId: number): Observable<Object> {
      return this.http.get(`${this.url1}/${attributeId}`);
    }
    createAttribute(attribute: Attribute): Observable<Response[]> {
      return this.http.post<Response[]>(`${this.url1}`, attribute);
    }
  
  
  
    getCustoms(): Observable<Object> {
      return this.http.get(`${this.url1}`);
    }
  
    unAssignedAttribute(attributeSetId: number,assignedAttributeId: any = [],searchTerm:any,Page: number, size: number,sort: number,typeId:any) : Observable<Object>{
      return this.http.post<Response[]>(`${this.url1}/unAssigndAttributes/${attributeSetId}/${searchTerm}?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`, assignedAttributeId);
    }
  
  
    checkDuplicateAttributeCode(attributeCode: any) : Observable<Object> {
      return this.http.get(`${this.url1}/codeExists/${attributeCode}`);
      }
  
      checkDuplicateFrontendLabel(frontendLabel: any,typeId) : Observable<Object> {
      return this.http.get(`${this.url1}/frontEndLableExists/${frontendLabel}?typeId=${typeId}`);
      }
  
  
    //   getAllLeadAttributeDropDown(entityTypeId: number) {
    // 	return this.http.get(`${this.url1}/dropdown/$}`);
    //   }
      getAllLeadAttributeDropDown(): Observable<Object> {
      return this.http.get(`${this.url1}/dropdown`);
      }
  
}
